
import React from "react";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { PersistGate } from "redux-persist/integration/react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import store, { persistor } from "./store";
import Theme from "components/template/Theme";
import Layout from "components/layout";
import { ErrorBoundary } from "components/shared";
import PageLoader from "components/shared/PageLoader";
import mockServer from "./mock";
import appConfig from "configs/app.config";
import "./assets/styles/app.css";
import "./locales";
import PreventBack from "PreventBack";
import { installToastDedup } from "utils/toastDedup";

// Only ever show one toast at a time (see utils/toastDedup).
installToastDedup();

const environment = process.env.NODE_ENV;

if (environment !== "production" && appConfig.enableMock) {
  mockServer({ environment });
}

function App() {
  return (
    <Provider store={store}>
      <PersistGate loading={<PageLoader />} persistor={persistor}>
        <BrowserRouter>
          <PreventBack /> 
          <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop={true}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
          />
          <Theme>
            <ErrorBoundary>
              <Layout />
            </ErrorBoundary>
          </Theme>
        </BrowserRouter>
      </PersistGate>
    </Provider>
  );
}

export default App;

